import { render } from "./BasicLocationInfo.vue?vue&type=template&id=7624708b&scoped=true"
import script from "./BasicLocationInfo.vue?vue&type=script&lang=js"
export * from "./BasicLocationInfo.vue?vue&type=script&lang=js"

import "./BasicLocationInfo.vue?vue&type=style&index=0&id=7624708b&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src804629530/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7624708b"]])

export default __exports__